import { Seo } from "@/components/Seo";
import { Hero } from "@/components/Hero";
import { StepsStrip } from "@/components/StepsStrip";
import { Editorial } from "@/components/Editorial";
import { WhatWeAccept } from "@/components/WhatWeAccept";
import { HowItWorks } from "@/components/HowItWorks";
import { Marquee } from "@/components/Marquee";
import { Testimonials } from "@/components/Testimonials";
import { ServiceAreas } from "@/components/ServiceAreas";
import { Faq } from "@/components/Faq";

export default function Home() {
    return (
        <main>
            <Seo
                title="Cash for Cars Toronto & GTA | Toronto Scrap Car Removal"
                description="Toronto Scrap Car Removal — top cash paid on the spot for junk, scrap and unwanted cars. Free same-day towing across Toronto & the GTA. Call (647) 507-3945."
            />
            <Hero />
            <StepsStrip />
            <Editorial />
            <WhatWeAccept />
            <HowItWorks />
            <Marquee />
            <Testimonials />
            <ServiceAreas />
            <Faq />
        </main>
    );
}
